import { useFollowingMembers } from '@/hooks/livemallclub/useFollow'
import { ButtonHTMLAttributes, MouseEvent, useState } from 'react'

// Icons
import { CheckIcon } from './CheckIcon'
import { PlusIcon } from './PlusIcon'
import { USER_ROLE } from '@/types/user-profile'
import useFollowParams from '@/hooks/useFollowerType'

const FollowButton = ({
  memberId,
  isFollowed = false,
  followeeType,
  ...props
}: Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'onClick'> & {
  memberId: string
  isFollowed?: boolean
  followeeType: USER_ROLE
}) => {
  const { handleAddFollowingMember } = useFollowingMembers()
  const [isFollowedState, setIsFollowedState] = useState<boolean>(isFollowed)
  const followerType = useFollowParams()

  const handleFollow = async (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    if (isFollowedState) return

    setIsFollowedState(true)
    const res = await handleAddFollowingMember({ followeeId: memberId, followeeType, followerType: followerType.role })
    if (!res.isSuccess) {
      setIsFollowedState(false)
    }
  }

  return (
    <button onClick={handleFollow} {...props}>
      {isFollowedState ? <CheckIcon /> : <PlusIcon />}
    </button>
  )
}

export default FollowButton
